import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const xIconApplePay: IconDefinition = {
  prefix: 'fal',
  iconName: 'apple-pay',
  icon: [
    47,
    20,
    [],
    '',
    'M8.6 2.61c-.69.9-1.48 1.29-2.36 1.19-.1-.9.2-1.74.89-2.53C7.72.48 8.48.06 9.42 0c.1.95-.17 1.82-.81 2.61zm.81 1.42c1.28.11 2.24.66 2.88 1.66h-.07c-1.13.79-1.67 1.84-1.62 3.16a4.22 4.22 0 0 0 .07.79c.05.26.11.49.18.67s.16.37.26.55.21.34.33.47l.33.36c.1.11.21.18.33.24a2.04 2.04 0 0 1 .3.16l.18.12.07.04c-.15.74-.49 1.53-1.03 2.37-.89 1.37-1.7 2.06-2.44 2.06-.34 0-.76-.11-1.26-.32-.49-.21-.94-.32-1.33-.32s-.84.11-1.33.32-.89.32-1.18.32c-.74.05-1.58-.66-2.51-2.13C.83 13.39.34 12.06.09 10.56a7.88 7.88 0 0 1 .52-4.39c.74-1.37 1.8-2.08 3.17-2.13.3 0 .62.07.96.2l.96.4c.3.13.52.2.66.2s.57-.14 1.26-.43S8.9 4 9.39 4.05zm7.38-2.85h5.39c.94 0 1.76.21 2.47.63s1.28 1.01 1.7 1.78c.42.76.63 1.65.63 2.65 0 1.48-.46 2.69-1.37 3.64s-2.08 1.42-3.51 1.42H19v5.22h-2.22V1.19zm2.22 1.98v6.09h2.58c.98 0 1.75-.26 2.29-.79s.81-1.28.81-2.25-.27-1.73-.81-2.25-1.3-.79-2.29-.79h-2.58zm12.03 13.52c-1.03 0-1.88-.3-2.55-.91-.66-.61-1-1.41-1-2.41 0-2 1.33-3.11 3.99-3.32l2.81-.16v-.87c0-1.27-.71-1.9-2.14-1.9-1.23 0-1.94.53-2.14 1.58h-1.99c0-.69.18-1.29.55-1.82a3.61 3.61 0 0 1 1.51-1.23c.64-.29 1.35-.43 2.14-.43 1.28 0 2.3.33 3.06.99s1.14 1.54 1.14 2.65v7.67h-2.07V14.7h-.07c-.64 1.32-1.72 1.98-3.25 1.98zm.59-1.82c.74 0 1.37-.24 1.88-.71a2.25 2.25 0 0 0 .78-1.74v-.87l-2.51.16c-1.43.05-2.14.58-2.14 1.58a1.39 1.39 0 0 0 .26.83c.17.24.41.42.7.55.3.13.64.2 1.03.2zm7.53 5.85h-.81v-1.9c.25.05.47.08.66.08.94 0 1.55-.53 1.85-1.58l.22-.71-3.77-11.23h2.29l2.66 9.09h.07l2.58-9.09h2.29l-3.91 11.78c-.44 1.37-.96 2.31-1.55 2.81s-1.45.75-2.58.75z',
  ],
};

export const xIconArrowsHorizontal: IconDefinition = {
  prefix: 'fal',
  iconName: 'arrows-h',
  icon: [
    48,
    48,
    [],
    '',
    'M39 28c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l6.29-6.29H19c-.55 0-1-.45-1-1s.45-1 1-1h25.59l-6.29-6.29c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l8 8c.1.1.17.21.22.33s.08.24.08.38h0a.92.92 0 0 1-.08.38c-.05.12-.12.23-.22.33l-8 8a.98.98 0 0 1-.71.29zM9 18c-.26 0-.51-.1-.71-.29l-8-8c-.1-.1-.17-.21-.22-.33A1.17 1.17 0 0 1-.01 9H0a.92.92 0 0 1 .08-.38c.05-.12.12-.23.22-.33l7.99-8C8.68-.1 9.31-.1 9.7.29s.39 1.02 0 1.41L3.41 8H29c.55 0 1 .45 1 1s-.45 1-1 1H3.41l6.29 6.29c.39.39.39 1.02 0 1.41a.98.98 0 0 1-.71.29z',
  ],
};

export const xIconBars: IconDefinition = {
  prefix: 'fal',
  iconName: 'bars',
  icon: [
    48,
    48,
    [],
    '',
    'M42,35H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h36c0.6,0,1,0.4,1,1S42.6,35,42,35z M42,25H6c-0.6,0-1-0.4-1-1s0.4-1,1-1  h36c0.6,0,1,0.4,1,1S42.6,25,42,25z M42,15H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h36c0.6,0,1,0.4,1,1S42.6,15,42,15z',
  ],
};

export const xIconBox: IconDefinition = {
  prefix: 'fal',
  iconName: 'box',
  icon: [
    48,
    48,
    [],
    '',
    'M41 48H7c-1.7 0-3-1.3-3-3V24H3c-1.7 0-3-1.3-3-3v-4c0-1.7 1.3-3 3-3h42c1.7 0 3 1.3 3 3v4c0 1.7-1.3 3-3 3h-1v21c0 1.7-1.3 3-3 3zm-9-2h9a.94.94 0 0 0 1-1V24H32v22zm-14 0h12V24H18v22zM6 24v21a.94.94 0 0 0 1 1h9V24H6zm37-2h2a.94.94 0 0 0 1-1v-4a.94.94 0 0 0-1-1H32v6h11zm-25 0h12v-6H18v6zM5 22h11v-6H3a.94.94 0 0 0-1 1v4a.94.94 0 0 0 1 1h2zm21-10c-.3 0-.5-.1-.7-.3s-.3-.6-.3-.9c.3-1.3 1.9-7.7 3.6-9.3.9-1 2.1-1.5 3.4-1.6 1.3 0 2.6.5 3.5 1.4a4.8 4.8 0 0 1 .1 6.9l-.1.1h0c-1.6 1.6-8.1 3.3-9.3 3.6 0 .1-.1.1-.2.1zm6.1-10.1c-.8 0-1.6.3-2.1.9-.8.8-1.9 4-2.6 6.8 2.8-.8 6-1.9 6.7-2.6l.1-.1c.5-.6.8-1.3.8-2.1s-.3-1.5-.9-2c-.5-.6-1.2-.9-2-.9zM22 12h-.2c-1.3-.3-7.7-1.9-9.3-3.6a4.96 4.96 0 0 1 0-6.8C13.4.7 14.6.1 15.9.1s2.6.5 3.5 1.4c1.7 1.7 3.3 8.1 3.6 9.3.1.3 0 .7-.3.9-.2.2-.4.3-.7.3zm-8.1-5c.8.8 4 1.9 6.7 2.6-.8-2.8-1.9-6-2.6-6.7-.5-.5-1.3-.8-2.1-.8s-1.5.3-2 .9c-1.1 1.1-1.1 2.8 0 4z',
  ],
};

export const xIconBoxAlt: IconDefinition = {
  prefix: 'fal',
  iconName: 'box-alt',
  icon: [
    48,
    48,
    [],
    '',
    'M25.8 47.4c-2.7 0-5.7-1-11-2.9-1.4-.5-3-1-4.8-1.6v.6c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2h5c3.6.1 6.9 1.5 9.4 4H30c1.6 0 2.9 1.3 3 2.9l8.5-2.8c2-.7 4.2-.2 5.8 1.2.2.1.4.4.5.6.5 1 .1 2.2-.9 2.7l-8.5 4.4c-6.4 3.4-9.3 4.9-12.6 4.9zM10 40.8a151.86 151.86 0 0 1 5.4 1.9c11.1 3.9 11.1 3.9 22-1.9l8.5-4.4c-1.1-1-2.6-1.3-3.9-.8L31.8 39c-.5.4-1.2.7-1.9.7H19a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h11a.94.94 0 0 0 1-1 .94.94 0 0 0-1-1h-6c-.3 0-.5-.1-.7-.3a12.03 12.03 0 0 0-8.3-3.7h-5v9.1zM2 29.5h0v14h6v-2-12H2zm38-2H22c-1.1 0-2-.9-2-2v-10c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h6.2c-.5-.3-1-.7-1.5-1l-.1-.1c-1.1-1.1-1.6-2.1-1.6-3 0-.7.3-1.4.9-2 1.4-1.4 3.1-1.2 4.9.7l.1.1c.8 1.1 1.5 2.2 2.1 3.4.5-1.2 1.2-2.3 2.1-3.4l.1-.1c1.9-1.9 3.5-2.1 5-.7.6.6.9 1.2.9 2 0 .9-.5 1.9-1.6 3l-.1.1c-.5.4-1 .7-1.5 1H42c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2v10c0 1.1-.9 2-2 2zm-8-2h8v-10h-8v10zm-10-10v10h8v-10h-8zm10-2h10v-4H32v4zm-12-4h0v4h10v-4H20zM26 5c1 .8 2.2 1.5 3.4 2-.5-1.2-1.2-2.3-2-3.4-1.4-1.4-1.8-1-2.1-.7s-.3.5-.3.5c0 .2.1.7 1 1.6zm8.6-1.4c-.8 1-1.5 2.2-2 3.4 1.2-.6 2.4-1.2 3.4-2 .9-.9 1-1.4 1-1.5s0-.2-.3-.5c-.3-.4-.7-.8-2.1.6zm2.1 2.1h0 0z',
  ],
};

export const xIconBuilding: IconDefinition = {
  prefix: 'fal',
  iconName: 'building',
  icon: [
    48,
    48,
    [],
    '',
    'M39 48H9c-1.7 0-3-1.3-3-3V7.6c0-.6.2-1.2.5-1.7l3.1-4.6C10.1.5 11.1 0 12.1 0H36c1 0 1.9.5 2.5 1.3l3.1 4.6c.2.5.4 1.1.4 1.7V45c0 1.7-1.3 3-3 3zm-11-2h11a.94.94 0 0 0 1-1V8H8v37a.94.94 0 0 0 1 1h11v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6zm-6 0h4v-6c0-1.1-.9-2-2-2s-2 .9-2 2v6zM8.9 6h30.3l-2.4-3.6c-.2-.2-.5-.4-.9-.4H12.1c-.3 0-.6.2-.8.4L8.9 6zM37 34h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5zm-5 2h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5zm-5 2h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5zm25-11h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5zm-5 2h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5zm-5 2h-6a.94.94 0 0 1-1-1v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v6a.94.94 0 0 1-1 1zm-5-2h4v-5c0-1.1-.9-2-2-2s-2 .9-2 2v5z',
  ],
};

export const xIconCalendar: IconDefinition = {
  prefix: 'fal',
  iconName: 'calendar',
  icon: [
    48,
    48,
    [],
    '',
    'M45,48H3c-1.7,0-3-1.3-3-3V7c0-1.7,1.3-3,3-3h7V1c0-0.6,0.4-1,1-1s1,0.4,1,1v3h24V1c0-0.6,0.4-1,1-1s1,0.4,1,1  v3h7c1.7,0,3,1.3,3,3v38C48,46.7,46.7,48,45,48z M2,16v29c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1V16H2z M2,14h44V7c0-0.6-0.4-1-1-1h-7  v5c0,0.6-0.4,1-1,1s-1-0.4-1-1V6H12v5c0,0.6-0.4,1-1,1s-1-0.4-1-1V6H3C2.4,6,2,6.5,2,7V14z',
  ],
};

export const xIconCheckCircle: IconDefinition = {
  prefix: 'fal',
  iconName: 'check-circle',
  icon: [
    48,
    48,
    [],
    '',
    'M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46C11.9 2 2 11.9 2 24s9.9 22 22 22 22-9.9 22-22S36.1 2 24 2zm-2.4 31.1c-.7 0-1.3-.2-1.9-.7l-8.4-6.7a1.08 1.08 0 0 1-.2-1.4 1.08 1.08 0 0 1 1.4-.2l8.4 6.7c.2.2.5.2.7.2.3 0 .5-.2.7-.4l12.8-17.3a1.08 1.08 0 0 1 1.4-.2 1.08 1.08 0 0 1 .2 1.4L24 31.9c-.5.7-1.2 1.1-2 1.2h-.4z',
  ],
};

export const xIconChevronDown: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-down',
  icon: [
    48,
    48,
    [],
    '',
    'M24.1 37.7H24c-.5 0-1-.3-1.4-.7L.3 11.9c-.4-.4-.3-1 .1-1.4s1-.3 1.4.1L24 35.7l22.3-25.1c.4-.4 1-.5 1.4-.1s.5 1 .1 1.4L25.6 37.1l-.2.2c-.4.3-.8.4-1.3.4z',
  ],
};

export const xIconChevronLeft: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-left',
  icon: [
    48,
    48,
    [],
    '',
    'M36.8 48a1.08 1.08 0 0 1-.7-.3L11 25.5l-.2-.2c-.4-.4-.5-.9-.5-1.4s.3-1 .7-1.4L36.1.3c.4-.4 1-.3 1.4.1s.3 1-.1 1.4L12.3 24l25.2 22.2c.4.4.5 1 .1 1.4-.2.3-.5.4-.8.4z',
  ],
};

export const xIconChevronRight: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-right',
  icon: [
    48,
    48,
    [],
    '',
    'M11.3 48c-.3 0-.6-.1-.7-.3-.4-.4-.3-1 .1-1.4L35.8 24 10.6 1.7c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l25.2 22.3.2.2c.4.4.5.9.5 1.4s-.3 1-.7 1.4L12 47.7a1.08 1.08 0 0 1-.7.3z',
  ],
};

export const xIconChevronUp: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-up',
  icon: [
    48,
    48,
    [],
    '',
    'M47.1 37.7c-.3 0-.6-.1-.7-.3L24.1 12.3 1.8 37.4c-.4.4-1 .5-1.4.1s-.5-1-.1-1.4L22.5 11l.2-.2c.4-.4.9-.5 1.4-.5s1 .3 1.4.7l22.3 25.1c.4.4.3 1-.1 1.4-.2.2-.4.2-.6.2z',
  ],
};

export const xIconClipboard: IconDefinition = {
  prefix: 'fal',
  iconName: 'clipboard',
  icon: [
    48,
    48,
    [],
    '',
    'M41 48H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10.3c.8-1.5 2.1-2.7 3.7-3.3 1.9-.8 4-.9 5.9-.1 1.7.7 3.1 1.9 3.9 3.5H41c1.7 0 3 1.3 3 3v38c0 1.6-1.3 2.9-3 2.9zM7 6a.94.94 0 0 0-1 1v38a.94.94 0 0 0 1 1h34a.94.94 0 0 0 1-1V7a.94.94 0 0 0-1-1H30.1c-.4 0-.8-.2-.9-.6-.6-1.4-1.7-2.5-3.1-3-1.4-.6-2.9-.5-4.3.1a5.85 5.85 0 0 0-2.9 2.9 1.1 1.1 0 0 1-1 .6H7zm22.2 36H11a.94.94 0 0 1-1-1V11a.94.94 0 0 1 1-1h26a.94.94 0 0 1 1 1v21.5c0 1.2-.4 2.3-1.2 3.3L33 40.3c-1 1.1-2.4 1.7-3.8 1.7zM12 40h17.2c.9 0 1.7-.4 2.3-1l3.8-4.5h0c.5-.5.7-1.2.7-1.9V12H12v28zm14-6h-9a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h9a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm5-8H17a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h14a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm0-8H17a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h14a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1z',
  ],
};

export const xIconCreditCard: IconDefinition = {
  prefix: 'fal',
  iconName: 'credit-card',
  icon: [
    48,
    48,
    [],
    '',
    'M43,41H5c-2.8,0-5-2.2-5-5V12c0-2.8,2.2-5,5-5h38c2.8,0,5,2.2,5,5v24C48,38.8,45.8,41,43,41z M2,17v19  c0,1.7,1.3,3,3,3h38c1.7,0,3-1.3,3-3V17H2z M2,15h44v-3c0-1.7-1.3-3-3-3H5c-1.7,0-3,1.3-3,3V15z M13,31H7c-0.6,0-1-0.4-1-1  s0.4-1,1-1h6c0.6,0,1,0.4,1,1S13.6,31,13,31z M41,25h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S41.6,25,41,25z M23,25H7  c-0.6,0-1-0.4-1-1s0.4-1,1-1h16c0.6,0,1,0.4,1,1S23.6,25,23,25z',
  ],
};

export const xIconDiamond: IconDefinition = {
  prefix: 'fal',
  iconName: 'diamond',
  icon: [
    48,
    48,
    [],
    '',
    'M24 48h-.3c-.5-.1-1-.4-1.3-.8L.5 16.5c-.3-.4-.5-.9-.5-1.4V15v-.1c0-.5.2-1 .5-1.4L9.9.8c.2-.2.4-.4.6-.5 0 0 .1 0 .1-.1.3-.1.6-.2.9-.2h25c.6 0 1.2.3 1.6.8l9.4 12.7c.3.4.5 1 .5 1.5s-.2 1-.5 1.5L25.6 47.2c-.1.2-.3.3-.5.5-.3.2-.7.3-1.1.3zm-7.7-32L24 43.3 31.7 16H16.3zm17.5 0l-7.6 27 19.2-27H33.8zM2.6 16l19.2 26.9L14.2 16H2.6zm31.8-2h11l-8-10.8-3 10.8zm-17.6 0h14.4L24 2.8 16.8 14zM2.6 14h11l-3-10.8-8 10.8zM25.8 2l6.8 10.6 3-10.6h-9.8zM12.3 2l3 10.6L22.2 2h-9.9z',
  ],
};

export const xIconDownload: IconDefinition = {
  prefix: 'fal',
  iconName: 'download',
  icon: [
    48,
    48,
    [],
    '',
    'M40.3 47H7.7A6.7 6.7 0 0 1 1 40.3v-3.8a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v3.8C3 42.9 5.1 45 7.7 45h32.5c2.6 0 4.7-2.1 4.7-4.7v-3.8a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v3.8C47 44 44 47 40.3 47zM24 37.2h0c-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.2l-14-14c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L23 33.8V2a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v31.8l12.3-12.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-14 14c-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1h0z',
  ],
};

export const xIconEdit: IconDefinition = {
  prefix: 'fal',
  iconName: 'edit',
  icon: [
    48,
    48,
    [],
    '',
    'M37 48H3c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h26a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1H3a.94.94 0 0 0-1 1v38a.94.94 0 0 0 1 1h34a.94.94 0 0 0 1-1V23a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v22c0 1.7-1.3 3-3 3zM15.8 33.3c-.3 0-.5-.1-.7-.3-.3-.3-.4-.7-.2-1.1l4.2-9.9c0-.1.1-.2.2-.3L36.9 4 40.5.4c.4-.4 1-.4 1.4 0l5.7 5.7c.4.4.4 1 0 1.4L44.1 11 26.4 28.7h0 0c-.1.1-.2.2-.3.2l-9.9 4.2c-.2.1-.3.2-.4.2zm4.5-9.2l-2.7 6.2 6.2-2.7-3.5-3.5zm1.1-1.7l4.2 4.2 16.3-16.3-4.2-4.2-16.3 16.3zM39.1 4.7l4.2 4.2 2.3-2.3-4.2-4.2-2.3 2.3z',
  ],
};

export const xIconFilter: IconDefinition = {
  prefix: 'fal',
  iconName: 'filter',
  icon: [
    48,
    48,
    [],
    '',
    'M22 48c-1.7 0-3-1.3-3-3V25.5L3.6 4.8C3.2 4.3 3 3.6 3 3c0-1.7 1.3-3 3-3h36c.6 0 1.3.2 1.8.6.6.5 1.1 1.2 1.2 2s-.1 1.6-.6 2.2L29 25.5V42a2.98 2.98 0 0 1-1.2 2.4l-4 3c-.5.4-1.2.6-1.8.6zM6 2a.94.94 0 0 0-1 1c0 .2 0 .4.2.6l15.6 21c.1.2.2.4.2.6V45a.94.94 0 0 0 1 1c.2 0 .4-.1.6-.2l4-3c.2-.2.4-.5.4-.8V25.2c0-.2.1-.4.2-.6l15.6-21c.2-.2.2-.5.2-.7 0-.3-.2-.5-.4-.7-.2-.1-.4-.2-.6-.2H6z',
  ],
};

export const xIconHeart: IconDefinition = {
  prefix: 'fal',
  iconName: 'heart',
  icon: [
    48,
    48,
    [],
    '',
    'M24 44.9c-.3 0-.5-.1-.7-.3L3.7 24.4C-.1 20.6-1.1 14.9 1.4 10c3.2-6.2 10.9-8.7 17.1-5.5 1.1.6 2.2 1.3 3.1 2.2L24 9.1l2.5-2.3c2.4-2.3 5.6-3.6 9-3.6s6.6 1.4 8.9 3.8c.9.9 1.6 1.9 2.2 3.1 2.4 4.8 1.5 10.6-2.4 14.4L24.7 44.6c-.2.2-.4.3-.7.3zM12.6 5.1c-3.9 0-7.6 2.1-9.5 5.8-2 4-1.2 8.9 2 12L24 42.4 42.9 23c3.2-3.2 4-8 2-12.1-.5-.9-1.1-1.8-1.9-2.6-2-2-4.7-3.2-7.5-3.2S30 6.2 27.9 8.2l-3.2 2.9c-.4.3-1 .3-1.3 0l-3.2-2.9c-.8-.8-1.7-1.4-2.6-1.9-1.7-.8-3.3-1.2-5-1.2z',
  ],
};

export const xIconHome: IconDefinition = {
  prefix: 'fal',
  iconName: 'home',
  icon: [
    48,
    48,
    [],
    '',
    'M39 48H9c-1.7 0-3-1.3-3-3V22.4l-4.3 4.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l23-23c.4-.4 1-.4 1.4 0l23 23c.4.4.4 1 0 1.4s-1 .4-1.4 0L42 22.4V45c0 1.7-1.3 3-3 3zm-8-2h8a.94.94 0 0 0 1-1V20.4l-16-16-16 16V45a.94.94 0 0 0 1 1h8V33c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v13zm-12 0h10V33a.94.94 0 0 0-1-1h-8a.94.94 0 0 0-1 1v13z',
  ],
};

export const xIconList: IconDefinition = {
  prefix: 'fal',
  iconName: 'clipboard-list',
  icon: [
    48,
    48,
    [],
    '',
    'M41 48H7c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3h26.6c.8 0 1.6.3 2.1.9l7.4 7.4c.6.6.9 1.3.9 2.1V45c0 1.7-1.3 3-3 3zM7 2a.94.94 0 0 0-1 1v42a.94.94 0 0 0 1 1h34a.94.94 0 0 0 1-1V10.4c0-.3-.1-.5-.3-.7l-7.4-7.4a1.08 1.08 0 0 0-.7-.3H7zm7.9 37c-.5 0-1-.2-1.4-.6l-2.2-2.2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.2 2.2 4.3-6c.3-.5.9-.6 1.4-.2.4.3.6.9.2 1.4l-4.3 6c-.1.1-.1.2-.2.2-.4.4-.9.6-1.4.6zM35 36h-8a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h8a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm-20.1-7c-.5 0-1-.2-1.4-.6l-2.2-2.2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.2 2.2 4.3-6c.3-.5.9-.6 1.4-.2.4.3.6.9.2 1.4l-4.3 6c-.1.1-.1.2-.2.2-.4.4-.9.6-1.4.6zM35 26h-8a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h8a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm-20.1-7c-.5 0-1-.2-1.4-.6l-2.2-2.2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.2 2.2 4.3-6c.3-.5.9-.6 1.4-.2.4.3.6.9.2 1.4l-4.3 6c-.1.1-.1.2-.2.3-.4.3-.9.5-1.4.5zM35 16h-8a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h8a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1z',
  ],
};

export const xIconLock: IconDefinition = {
  prefix: 'fal',
  iconName: 'lock',
  icon: [
    48,
    48,
    [],
    '',
    'M39 48H9c-1.7 0-3-1.3-3-3V21c0-1.7 1.3-3 3-3h3v-6A12.04 12.04 0 0 1 24 0a12.04 12.04 0 0 1 12 12v6h3c1.7 0 3 1.3 3 3v24c0 1.7-1.3 3-3 3zM9 20a.94.94 0 0 0-1 1v24a.94.94 0 0 0 1 1h30a.94.94 0 0 0 1-1V21a.94.94 0 0 0-1-1H9zm5-2h20v-6c0-5.5-4.5-10-10-10S14 6.5 14 12v6zm10 21a.94.94 0 0 1-1-1v-5.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2 2.8V38a.94.94 0 0 1-1 1zm0-10a.94.94 0 0 0-1 1 .94.94 0 0 0 1 1 .94.94 0 0 0 1-1 .94.94 0 0 0-1-1z',
  ],
};

export const xIconLuggageCart: IconDefinition = {
  prefix: 'fal',
  iconName: 'luggage-cart',
  icon: [
    48,
    48,
    [],
    '',
    'M28 48a4.95 4.95 0 0 1-5-5 4.95 4.95 0 0 1 5-5 4.95 4.95 0 0 1 5 5 4.95 4.95 0 0 1-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM8 48a4.95 4.95 0 0 1-5-5 4.95 4.95 0 0 1 5-5 4.95 4.95 0 0 1 5 5 4.95 4.95 0 0 1-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm20.7-4H1a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h2V17c0-1.7 1.3-3 3-3h2V5c0-1.7 1.3-3 3-3h10c1.7 0 3 1.3 3 3v9h2c1.7 0 3 1.3 3 3v17c1.3-.1 2.4-1.1 2.7-2.4L37.4 4c.5-2.3 2.5-4 4.9-4H47a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1h-4.7c-1.4 0-2.7 1-2.9 2.4L33.6 32c-.4 2.3-2.5 4-4.9 4zM5 34h22V17a.94.94 0 0 0-1-1h-5v10c0 .4-.2.7-.6.9-.3.2-.7.1-1-.1L16 24.2l-3.4 2.5c-.3.2-.7.3-1 .1-.4-.1-.6-.4-.6-.8V16H6a.94.94 0 0 0-1 1v17zm11-12c.2 0 .4.1.6.2L19 24v-8h-6v8l2.4-1.8c.2-.1.4-.2.6-.2zm-6-8h12V5a.94.94 0 0 0-1-1H11a.94.94 0 0 0-1 1v9z',
  ],
};

export const xIconMapPin: IconDefinition = {
  prefix: 'fal',
  iconName: 'map-pin',
  icon: [
    48,
    48,
    [],
    '',
    'M24 47.6c-.4 0-.7-.1-1.1-.3-.2-.2-.5-.4-.6-.6C18 39.9 8 23.5 8 16.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 7.1-10 23.5-14.3 30.2-.4.7-1 1-1.7 1zm0-45.2c-7.7 0-14 6.3-14 14 0 5.4 7.2 18.6 14 29.2 3.3-5.1 14-22.4 14-29.2 0-7.7-6.3-14-14-14zm0 21c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-12a4.95 4.95 0 0 0-5 5 4.95 4.95 0 0 0 5 5 4.95 4.95 0 0 0 5-5 4.95 4.95 0 0 0-5-5z',
  ],
};

export const xIconMinus: IconDefinition = {
  prefix: 'fal',
  iconName: 'minus',
  icon: [48, 48, [], '', 'M47,25H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h46c0.6,0,1,0.4,1,1S47.6,25,47,25z'],
};

export const xIconPercent: IconDefinition = {
  prefix: 'fal',
  iconName: 'percent',
  icon: [
    48,
    48,
    [],
    '',
    'M45 40H3c-1.7 0-3-1.3-3-3v-7a.94.94 0 0 1 1-1 4.95 4.95 0 0 0 5-5 4.95 4.95 0 0 0-5-5 .94.94 0 0 1-1-1v-7c0-1.7 1.3-3 3-3h42c1.7 0 3 1.3 3 3v7a.94.94 0 0 1-1 1 4.95 4.95 0 0 0-5 5 4.95 4.95 0 0 0 5 5 .94.94 0 0 1 1 1v7c0 1.7-1.3 3-3 3zM2 30.9V37a.94.94 0 0 0 1 1h42a.94.94 0 0 0 1-1v-6.1c-3.4-.5-6-3.4-6-6.9s2.6-6.4 6-6.9V11a.94.94 0 0 0-1-1H3a.94.94 0 0 0-1 1v6.1c3.4.5 6 3.4 6 6.9s-2.6 6.4-6 6.9zM30 34c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-14 5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l16-16c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-16 16c-.2.2-.4.3-.7.3zm2-11c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  ],
};

export const xIconPhone: IconDefinition = {
  prefix: 'fal',
  iconName: 'phone',
  icon: [
    48,
    48,
    [],
    '',
    'M37 47c-1.5 0-3-.4-4.4-1.3-12.1-8-22.3-18.3-30.3-30.3-2.1-3.1-1.7-7.3 1-10L6 2.6C7.1 1.6 8.5 1 10 1s2.9.6 4 1.6l4.9 4.9c2.2 2.2 2.2 5.8 0 8l-1 1a109.2 109.2 0 0 0 13.6 13.6l1-1c2.2-2.2 5.8-2.2 8 0l4.9 4.9c1.1 1.1 1.6 2.5 1.6 4s-.6 2.9-1.6 4l-2.7 2.7C41.1 46.2 39.1 47 37 47zM10 3c-1 0-1.9.4-2.6 1.1L4.7 6.8c-2 2-2.3 5.1-.8 7.5 8 11.8 18 21.8 29.9 29.7 2.3 1.5 5.5 1.2 7.5-.7l2.7-2.7c.6-.7 1-1.6 1-2.6s-.4-1.9-1-2.5l-5-5c-1.4-1.4-3.7-1.4-5.1 0l-1.6 1.6a.94.94 0 0 1-1.3.1c-5.5-4.5-10.6-9.6-15.2-15.2-.3-.4-.3-1 .1-1.3l1.6-1.6c1.4-1.4 1.4-3.7 0-5.1l-4.9-4.9C11.9 3.4 11 3 10 3z',
  ],
};

export const xIconPlus: IconDefinition = {
  prefix: 'fal',
  iconName: 'plus',
  icon: [
    48,
    48,
    [],
    '',
    'M24,47c-0.6,0-1-0.4-1-1V25H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h21V2c0-0.6,0.4-1,1-1s1,0.4,1,1v21h21  c0.6,0,1,0.4,1,1s-0.4,1-1,1H25v21C25,46.6,24.6,47,24,47z',
  ],
};

export const xIconQuestionCircle: IconDefinition = {
  prefix: 'fal',
  iconName: 'question-circle',
  icon: [
    48,
    48,
    [],
    '',
    'M24 47C11.3 47 1 36.7 1 24S11.3 1 24 1s23 10.3 23 23-10.3 23-23 23zm0-44C12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21S35.6 3 24 3zm0 33a1.54 1.54 0 0 1-1.5-1.5A1.54 1.54 0 0 1 24 33a1.54 1.54 0 0 1 1.5 1.5A1.54 1.54 0 0 1 24 36zm0-5a.94.94 0 0 1-1-1v-.8c0-1 .3-1.9.8-2.7s1.3-1.5 2.2-1.8c.8-.4 1.5-.9 2.1-1.7.5-.7.8-1.6.9-2.5s-.1-1.8-.5-2.6-1-1.5-1.8-2-1.6-.8-2.5-.8-1.8.2-2.6.6-1.5 1.1-1.9 1.8c-.5.7-.7 1.6-.7 2.5a.94.94 0 0 1-1 1 .94.94 0 0 1-1-1c0-1.3.3-2.5 1-3.6.6-1.1 1.6-2 2.7-2.6s2.4-.9 3.6-.8c1.3.1 2.5.4 3.5 1.1 1.1.7 1.9 1.7 2.5 2.8s.8 2.4.7 3.7-.5 2.5-1.3 3.5c-.7 1-1.7 1.8-2.9 2.3-.5.2-1 .6-1.3 1.1s-.5 1.1-.5 1.7v.8a.94.94 0 0 1-1 1z',
  ],
};

export const xIconScroll: IconDefinition = {
  prefix: 'fal',
  iconName: 'scroll',
  icon: [
    48,
    48,
    [],
    '',
    'M30 48H4c-.4 0-.8-.3-.9-.7s0-.9.3-1.1l.2-.2C5.7 44.4 7 41.9 7 39.3V6a6.02 6.02 0 0 1 6-6h26 .1c3 0 5.6 2.3 5.9 5.4V6v7c0 1.7-1.3 3-3 3h-7v23.3c0 3.3-1.6 6.4-4.2 8.4l-.2.2c-.2 0-.4.1-.6.1zM6.5 46h23.1c2.1-1.6 3.3-4.1 3.3-6.7v-33c0-1.6.6-3.1 1.6-4.3H13c-2.2 0-4 1.8-4 4v33.3c0 2.4-.9 4.8-2.5 6.7zM35 14h7a.94.94 0 0 0 1-1V6v-.4C42.8 3.5 41 2 39 2h-.1-.3c-2.1.3-3.6 2.1-3.6 4.3V14zM22 40h-9a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h9a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm6-6H13a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h15a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm0-6H13a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h15a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm0-6H13a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h15a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm0-6H17a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h11a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1zm-10-6h-5a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h5a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1z',
  ],
};

export const xIconSearch: IconDefinition = {
  prefix: 'fal',
  iconName: 'search',
  icon: [
    48,
    48,
    [],
    '',
    'M47 48c-.3 0-.5-.1-.7-.3L35.1 36.5C31.4 39.9 26.4 42 21 42 9.4 42 0 32.6 0 21S9.4 0 21 0s21 9.4 21 21c0 5.4-2.1 10.4-5.5 14.1l11.2 11.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM21 2C10.5 2 2 10.5 2 21s8.5 19 19 19 19-8.5 19-19S31.5 2 21 2z',
  ],
};

export const xIconSearchMinus: IconDefinition = {
  prefix: 'fal',
  iconName: 'search-minus',
  icon: [
    48,
    48,
    [],
    '',
    'M47 48c-.3 0-.5-.1-.7-.3L35.1 36.5C31.4 39.9 26.4 42 21 42 9.4 42 0 32.6 0 21S9.4 0 21 0s21 9.4 21 21c0 5.4-2.1 10.4-5.5 14.1l11.2 11.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM21 2C10.5 2 2 10.5 2 21s8.5 19 19 19 19-8.5 19-19S31.5 2 21 2zm10 20H11a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h20a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1z',
  ],
};

export const xIconSearchPlus: IconDefinition = {
  prefix: 'fal',
  iconName: 'search-plus',
  icon: [
    48,
    48,
    [],
    '',
    'M47 48c-.3 0-.5-.1-.7-.3L35.1 36.5C31.4 39.9 26.4 42 21 42 9.4 42 0 32.6 0 21S9.4 0 21 0s21 9.4 21 21c0 5.4-2.1 10.4-5.5 14.1l11.2 11.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM21 2C10.5 2 2 10.5 2 21s8.5 19 19 19 19-8.5 19-19S31.5 2 21 2zm0 30a.94.94 0 0 1-1-1v-9h-9a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h9v-9a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v9h9a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1h-9v9a.94.94 0 0 1-1 1z',
  ],
};

export const xIconShare: IconDefinition = {
  prefix: 'fal',
  iconName: 'share',
  icon: [
    48,
    48,
    [],
    '',
    'M39 48c-1.4 0-2.7-.3-4-.9-2.2-1.1-3.8-2.9-4.5-5.2-.7-2-.6-4 .1-6l-14-7c-.9 1.3-2.1 2.4-3.5 3.2-4.4 2.2-9.9.4-12.1-4-1.1-2.2-1.2-4.6-.5-6.9A8.75 8.75 0 0 1 5 15.9c2.1-1.1 4.6-1.2 6.9-.5 2 .7 3.6 1.9 4.7 3.6l14-7c-.4-.9-.6-2-.6-3 0-2.4.9-4.7 2.7-6.4C34.4.9 36.6 0 39 0s4.7.9 6.4 2.7C47.1 4.3 48 6.6 48 9c0 5-4.1 9-9 9-3.1 0-5.9-1.6-7.5-4.1l-14 7c.7 2 .7 4.2 0 6.2l14 7C33.1 31.5 36 30 39 30h0 0c1.4 0 2.8.3 4 .9 2.2 1.1 3.8 2.9 4.5 5.2.8 2.3.6 4.7-.5 6.9-1.5 3.2-4.7 5-8 5zm-6.3-12.1c-.8 1.7-.9 3.5-.4 5.3.6 1.8 1.8 3.2 3.5 4s3.6 1 5.3.4c1.8-.6 3.2-1.8 4-3.5s1-3.6.4-5.3c-.6-1.8-1.8-3.2-3.5-4-1-.5-2-.7-3.1-.7h0c-2.6-.1-5 1.4-6.2 3.8zM9 17c-1.1 0-2.1.2-3.1.7-1.7.8-2.9 2.3-3.5 4-.6 1.8-.5 3.7.4 5.3 1.7 3.5 5.9 4.9 9.4 3.1 1.3-.7 2.5-1.8 3.1-3.1 1-1.9 1-4.3 0-6.2h0c-.8-1.7-2.3-2.9-4-3.5-.8-.2-1.6-.3-2.3-.3zm30-1c3.9 0 7-3.1 7-7 0-1.9-.7-3.6-2-5-1.3-1.3-3.1-2-5-2s-3.6.7-5 2c-1.3 1.3-2 3.1-2 5 0 1.1.3 2.2.7 3.2A7.09 7.09 0 0 0 39 16z',
  ],
};

export const xIconShareAlt: IconDefinition = {
  prefix: 'fal',
  iconName: 'share-alt',
  icon: [
    48,
    48,
    [],
    '',
    'M43 43c-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4l3-4.4H36c-5.5 0-7.8-3.4-9.8-6.4S22.5 25 18 25H1a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h17c4.5 0 6.2-2.6 8.2-5.6S30.5 11 36 11h9.1l-3-4.4c-.3-.5-.2-1.1.3-1.4s1.1-.2 1.4.3l4 6c.1.2.2.4.2.6s-.1.4-.2.6l-4 6c-.3.5-.9.6-1.4.3s-.6-.9-.3-1.4l3-4.4H36c-4.5 0-6.2 2.6-8.2 5.6-1.3 2-2.8 4.2-5.3 5.4 2.5 1.2 3.9 3.4 5.3 5.4 2 3 3.7 5.6 8.2 5.6h9.1l-3-4.4c-.3-.5-.2-1.1.3-1.4s1.1-.2 1.4.3l4 6c.1.2.2.4.2.6s-.1.4-.2.6l-4 6c-.2-.1-.5.1-.8.1z',
  ],
};

export const xIconShippingFast: IconDefinition = {
  prefix: 'fal',
  iconName: 'shipping-fast',
  icon: [
    48,
    48,
    [],
    '',
    'M38,42c-3.3,0-6-2.7-6-6s2.7-6,6-6c2.6,0,4.8,1.7,5.7,4H46V9c0-0.6-0.4-1-1-1H19c-0.6,0-1,0.4-1,1v18  c0,0.6-0.4,1-1,1s-1-0.4-1-1V16h-4v6c0,1.7-1.3,3-3,3H2v7h6c0.6,0,1,0.4,1,1s-0.4,1-1,1H2v1c0,0.6,0.4,1,1,1h4c0.6,0,1,0.4,1,1  s-0.4,1-1,1H3c-1.7,0-3-1.3-3-3V23c0-5,4-9,9-9h7V9c0-1.7,1.3-3,3-3h26c1.7,0,3,1.3,3,3v26c0,0.6-0.4,1-1,1h-3  C44,39.3,41.3,42,38,42z M38,32c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S40.2,32,38,32z M2,23h7c0.6,0,1-0.4,1-1v-6H9  C5.1,16,2,19.1,2,23z M16,42c-3.3,0-6-2.7-6-6s2.7-6,6-6c2.6,0,4.8,1.7,5.7,4H29c0.6,0,1,0.4,1,1s-0.4,1-1,1h-7  C22,39.3,19.3,42,16,42z M16,32c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S18.2,32,16,32z',
  ],
};

export const xIconShoppingBag: IconDefinition = {
  prefix: 'fal',
  iconName: 'shopping-bag',
  icon: [
    48,
    48,
    [],
    '',
    'M39 48H9c-1.3 0-2.6-.5-3.5-1.5-1-.9-1.5-2.2-1.5-3.5l.1-2.1 1.8-26c.1-.8.4-1.5 1-2.1.5-.5 1.3-.8 2.1-.8h5v-2c0-2.7 1-5.2 2.9-7.1S21.3 0 24 0s5.2 1 7.1 2.9S34 7.3 34 10v2h5c.8 0 1.6.3 2.1.8.6.5.9 1.3 1 2.1l1.8 26L44 43c0 1.3-.5 2.6-1.5 3.5-.9 1-2.2 1.5-3.5 1.5zM9 14c-.3 0-.6.1-.8.3s-.3.5-.4.8L6 41.1V43c0 .8.3 1.6.9 2.1.5.6 1.3.9 2.1.9h30c.8 0 1.6-.3 2.1-.9.6-.6.9-1.3.9-2.1 0-.6 0-1.3-.1-1.9l-1.8-26c0-.3-.1-.6-.4-.8-.1-.2-.4-.3-.7-.3h-5v5a.94.94 0 0 1-1 1 .94.94 0 0 1-1-1v-5H16v5a.94.94 0 0 1-1 1 .94.94 0 0 1-1-1v-5H9zm7-2h16v-2c0-2.1-.8-4.1-2.3-5.7C28.1 2.8 26.1 2 24 2s-4.1.8-5.7 2.3C16.8 5.9 16 7.9 16 10v2z',
  ],
};

export const xIconSync: IconDefinition = {
  prefix: 'fal',
  iconName: 'sync',
  icon: [
    48,
    48,
    [],
    '',
    'M23.9 42c-4.7 0-9.2-1.8-12.6-5.2-.4-.4-.4-1 0-1.4s1-.4 1.4 0c3.9 3.9 9.5 5.5 14.9 4.2 7.4-1.8 12.5-8.5 12.5-16l-4.8 5.7c-.4.4-1 .5-1.4.1s-.5-1-.1-1.4l6.3-7.5c0-.1.1-.2.2-.2.2-.2.5-.3.8-.3s.6.2.8.4l5.6 8.3c.3.5.2 1.1-.3 1.4s-1.1.2-1.4-.3l-3.6-5.4c-.3 8-6 15.1-14 17-1.5.4-2.9.6-4.3.6zM7 30c-.4 0-.7-.2-.8-.4L.6 21.3c-.3-.5-.2-1.1.3-1.4s1.1-.2 1.4.3L5.5 25c-.1-3.5.9-6.9 2.7-9.9 2.6-4.3 6.7-7.3 11.5-8.5h.2c6.5-1.5 13.2.6 17.6 5.6.4.4.3 1-.1 1.4s-1 .3-1.4-.1c-3.9-4.4-9.9-6.3-15.7-5h-.2c-4.3 1.1-8 3.8-10.3 7.6a17.25 17.25 0 0 0-2.3 10.6l5-6c.4-.4 1-.5 1.4-.1s.5 1 .1 1.4l-6.4 7.7c0 .2-.3.3-.6.3z',
  ],
};

export const xIconTag: IconDefinition = {
  prefix: 'fal',
  iconName: 'tag',
  icon: [
    48,
    48,
    [],
    '',
    'M30 47.5h-.3c-.6-.1-1.1-.4-1.4-.8L2.2 20.6C1.2 19.5.6 18 .5 16.5v-13c0-1.7 1.3-3 3-3h13c1.5.1 3 .7 4.1 1.7l26.2 26.2c.9.7 1.1 1.9.4 2.9-.3.5-.8.8-1.4.9l-10.5 3.2-3.2 10.5c-.1.5-.4 1-.8 1.3-.4.2-.8.3-1.3.3zm-13.6-45H3.5a.94.94 0 0 0-1 1v13c.1 1 .5 2 1.2 2.7l26.1 26.1.1.1h.1c0-.1.1-.2.1-.2l3.4-11.1c.1-.3.3-.6.7-.7L45.3 30h.2c.1-.1.1-.2 0-.2l-.1-.1L19.2 3.6c-.8-.7-1.8-1.1-2.8-1.1zm-4.9 14a4.95 4.95 0 0 1-5-5 4.95 4.95 0 0 1 5-5 4.95 4.95 0 0 1 5 5c0 2.8-2.3 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3a3.01 3.01 0 0 0-3-3z',
  ],
};

export const xIconTicket: IconDefinition = {
  prefix: 'fal',
  iconName: 'ticket',
  icon: [
    48,
    48,
    [],
    '',
    'M43 34H5a4.95 4.95 0 0 1-5-5V5a4.95 4.95 0 0 1 5-5h38a4.95 4.95 0 0 1 5 5v24a4.95 4.95 0 0 1-5 5zm-27.2-2H43c1.7 0 3-1.3 3-3V14H17.6l2.8 2.8c.4.4.4 1 0 1.4s-1 .4-1.4 0L15.8 15v17zM2 14v15c0 1.7 1.3 3 3 3h8.8V15.1l-3.2 3.2c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l2.9-2.9c0 0-10.1 0-10.1 0zm19.1-2H46V5c0-1.7-1.3-3-3-3H15.8v7.1c1.3-2.1 3.3-4.4 5.7-3.5 1.5.5 2.3 1.8 2.1 3.3-.2 1-1.1 2.2-2.5 3.1zM2 12h6.7C7.1 11.1 6.2 9.9 6 8.7c-.2-1.4.6-2.7 2.1-3.3 2.4-.9 4.4 1.5 5.7 3.6V2H5C3.3 2 2 3.3 2 5v7zm18.5-4.7c-1.2 0-2.7 2.1-3.6 3.9 3.1-.4 4.5-1.8 4.7-2.8 0 0 .1-1.1-1.1-1.1zM8 8.4c.1 1 1.6 2.4 4.7 2.8-.9-1.8-2.3-3.9-3.6-3.9 0 0-1.2-.1-1.1 1.1z',
  ],
};

export const xIconTimes: IconDefinition = {
  prefix: 'fal',
  iconName: 'times',
  icon: [
    48,
    48,
    [],
    '',
    'M47 48c-.3 0-.5-.1-.7-.3L24 25.4 1.7 47.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4L22.6 24 .3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0L24 22.6 46.3.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L25.4 24l22.3 22.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z',
  ],
};

export const xIconTimesCircle: IconDefinition = {
  prefix: 'fal',
  iconName: 'times-circle',
  icon: [
    48,
    48,
    [],
    '',
    'M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46C11.9 2 2 11.9 2 24s9.9 22 22 22 22-9.9 22-22S36.1 2 24 2zm10 33c-.3 0-.5-.1-.7-.3L24 25.4l-9.3 9.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l9.3-9.3-9.3-9.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l9.3 9.3 9.3-9.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L25.4 24l9.3 9.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z',
  ],
};

export const xIconTrash: IconDefinition = {
  prefix: 'fal',
  iconName: 'trash',
  icon: [
    48,
    48,
    [],
    '',
    'M34.4 48H13.6c-2.6 0-4.7-1.9-5-4.5L5.1 10H1a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h5 8V3c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v5h8 5a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1h-4.1l-3.5 33.5c-.3 2.6-2.4 4.5-5 4.5zM7.1 10l3.5 33.3c.2 1.5 1.4 2.7 3 2.7h20.8c1.5 0 2.8-1.2 3-2.7L40.9 10H7.1zM16 8h16V3a.94.94 0 0 0-1-1H17a.94.94 0 0 0-1 1v5zm16 32c-.6 0-1-.5-1-1l1-21c0-.6.5-1 1-1 .6 0 1 .5 1 1l-1 21c0 .6-.5 1-1 1zm-16 0c-.5 0-1-.4-1-1l-1-21a.94.94 0 0 1 1-1c.5 0 1 .4 1 1l1 21c0 .5-.4 1-1 1zm8 0a.94.94 0 0 1-1-1V18a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v21a.94.94 0 0 1-1 1z',
  ],
};

export const xIconUpload: IconDefinition = {
  prefix: 'fal',
  iconName: 'upload',
  icon: [
    48,
    48,
    [],
    '',
    'M40.3 47H7.7A6.7 6.7 0 0 1 1 40.3v-3.8a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v3.8C3 42.9 5.1 45 7.7 45h32.5c2.6 0 4.7-2.1 4.7-4.7v-3.8a.94.94 0 0 1 1-1 .94.94 0 0 1 1 1v3.8C47 44 44 47 40.3 47zM24 37.2a.94.94 0 0 1-1-1V4.4L10.7 16.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l14-14c.1-.1.2-.2.3-.2.1-.1.3-.1.4-.1h0 0c.1 0 .3 0 .4.1.1 0 .2.1.3.2l14 14c.4.4.4 1 0 1.4s-1 .4-1.4 0L25 4.4v31.8a.94.94 0 0 1-1 1z',
  ],
};

export const xIconUser: IconDefinition = {
  prefix: 'fal',
  iconName: 'user',
  icon: [
    48,
    48,
    [],
    '',
    'M42 46.5H6a.94.94 0 0 1-1-1c0-10.5 8.5-19 19-19s19 8.5 19 19a.94.94 0 0 1-1 1zm-35-2h34c-.5-8.9-7.9-16-17-16s-16.5 7.1-17 16zm17-19a12.04 12.04 0 0 1-12-12 12.04 12.04 0 0 1 12-12 12.04 12.04 0 0 1 12 12 12.04 12.04 0 0 1-12 12zm0-22c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z',
  ],
};

export const xIconWarehouse: IconDefinition = {
  prefix: 'fal',
  iconName: 'warehouse',
  icon: [
    48,
    48,
    [],
    '',
    'M39 46h-.1H9.1h-.2H1a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h1V16c-1.1 0-2-.9-2-2v-4c0-.3.1-.5.3-.7C4.6 4.8 13.7 2 24 2s19.4 2.8 23.7 7.3c.2.2.3.4.3.7v4c0 1.1-.9 2-2 2v28h1a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1h-7.9-.1zm1-2h4V16H4v28h4V23c0-1.7 1.3-3 3-3h26c1.7 0 3 1.3 3 3v21zm-30 0h28v-4H10v4zm0-6h28v-4H10v4zm0-6h28v-4H10v4zm0-6h28v-3a.94.94 0 0 0-1-1H11a.94.94 0 0 0-1 1v3zm35.1-12h.9v-3.6C41.9 6.5 33.6 4 24 4S6.1 6.5 2 10.4V14h.9.2 41.7.3zm-17.6-4h-7a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1h7a.94.94 0 0 1 1 1 .94.94 0 0 1-1 1z',
  ],
};
